import React, { useState } from 'react';
import './SpaceMonkeyLogo.css';

// Official Space Monkey Arcade logo.
//
// To show the real logo, place the uploaded image file at:
//   public/space-monkey-logo.jpeg
// It is referenced by URL (not imported) so the build never fails if the
// file is missing. When the file is absent, a styled wordmark renders instead.
const LOGO_SRC = `${process.env.PUBLIC_URL}/space-monkey-logo.jpeg`;

const SpaceMonkeyLogo = ({ light = false, size = 'md', tagline = true, className = '' }) => {
  const [imageFailed, setImageFailed] = useState(false);

  if (!imageFailed) {
    return (
      <img
        src={LOGO_SRC}
        alt="Space Monkey Arcade"
        className={`sm-logo-img sm-logo-img-${size} ${className}`}
        onError={() => setImageFailed(true)}
      />
    );
  }

  // Fallback wordmark (renders only if the logo image is not present)
  return (
    <span className={`sm-logo-wm sm-logo-wm-${size} ${light ? 'sm-logo-wm-light' : ''} ${className}`}>
      <span className="sm-logo-wm-mark" aria-hidden="true">SM</span>
      <span className="sm-logo-wm-text">
        <span className="sm-logo-wm-name">SPACE MONKEY</span>
        {tagline && <span className="sm-logo-wm-tag">Arcade</span>}
      </span>
    </span>
  );
};

export default SpaceMonkeyLogo;
